import { cn } from "@omni/utils/styles";

import { useSidebarContext } from "@/components/Navigation/Sidebar/context/sidebar.context";

type Props = {
    className?: string;
};

export const InnerHtml = ({ className }: Props) => {
    const { innerHtml } = useSidebarContext();

    if (!innerHtml) return null;

    return (
        <div
            className={cn(className)}
            dangerouslySetInnerHTML={{ __html: innerHtml }}
        />
    );
};
